import { cn } from 'lib/utils';
import { useTheme } from 'components/core/theme-provider';
import type { ChatInputButton } from 'pages/chat/chat';

interface ChatQuickActionsProps {
  buttons: ChatInputButton[];
  className?: string;
}

export function ChatQuickActions({ buttons, className }: ChatQuickActionsProps) {
  const { theme } = useTheme();

  if (buttons.length === 0) {
    return null;
  }

  return (
    <div
      className={cn(
        // Mobile + tablet: parent hides this block. Desktop: row of chips.
        'flex w-full flex-row flex-wrap justify-center gap-2',
        className
      )}
    >
      {buttons.map((button) => (
        <button
          key={button.id}
          type="button"
          aria-pressed={button.isSelected}
          aria-label={button.label}
          disabled={button.isDisabled}
          onClick={button.onClick}
          className={cn(
            'flex w-auto items-center justify-center gap-2 rounded-full border border-[#e7e7e7] bg-white px-4 py-2 transition-colors xl:gap-3',
            'hover:bg-muted disabled:cursor-not-allowed disabled:opacity-30',
            theme === 'dark' && 'border-gray-500 bg-black-400',
            button.isSelected && 'border-primary bg-primary/5 text-primary',
            !button.isSelected &&
            (theme === 'dark'
              ? 'text-white'
              : '[&_svg]:text-[#6D6D6D]')
          )}
        >
          <span className="flex size-5 shrink-0 items-center justify-center [&_svg]:size-5 dark:[&_svg]:text-[hsla(66,100%,88%,1)]">
            {button.icon}
          </span>
          {button.label && (
            <span
              className={cn(
                'whitespace-nowrap text-sm font-normal text-[#454545] dark:text-[#F6F6F6]',
                button.isSelected && 'text-primary'
              )}
            >
              {button.label}
            </span>
          )}
        </button>
      ))}
    </div>
  );
}
